import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface SelectedApplicationStore {
  /** The application id the borrower has explicitly chosen in the navbar selector. */
  selectedId: string | null;
  setSelectedId: (id: string | null) => void;
}

/**
 * Which application the borrower is currently viewing. `null` means "no explicit
 * choice" — consumers fall back to the default (earliest-created active app, see
 * `useActiveApplicantApplicationQuery`). Persisted so the choice survives reloads.
 */
export const useSelectedApplicationStore = create<SelectedApplicationStore>()(
  persist(
    (set) => ({
      selectedId: null,
      setSelectedId: (selectedId) => set({ selectedId }),
    }),
    {
      name: "selected-application-store",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
